import React, { Component } from "react";

//components
import CariUploadDocumentsPanel from "../../../components/cari_app_form_components/CariUploadDocumentsPanel";
import LoadingPgTemplate from "../../../../../generic_components/view/LoadingPgTemplate";
import CariAppFormNavBtnBar from "../../../components/cari_app_form_components/CariAppFormNavBtnBar";
import CariMainPgFooterView from "../../cari_template_view/CariMainPgFooterView";

//generic functions
import {
    isEmpty
} from "../../../../../functions/generic_functions";

import { 
    cari_app_form_pg_1_url, 
    cari_app_form_pg_2_url, 
    cari_app_form_pg_3_url, 
    cari_app_form_pg_4_url 
} from "../../../../../router/static_routes";

/*
    props:

        onFileUpload => call back function to handle file upload
        onFileDelete => call back function to handle file deletion

        pageLoaded => conditional rendering upon api load
        maxFileSize => max file sizes for fileUploadBoxes
        postData => the uploaded file data in an array

        onChangeSetParentState => the function to set the parent state, in this case, call a refresh on the load api data after a file is uploaded
        maxFileSize => max file size for documents
*/

class CariAppFormViewPg3 extends Component {
    constructor(Props) {
        super(Props);

        //helper functions
        this.getCariFormPgNum = this.getCariFormPageNum.bind(this);
    }

    getCariFormPageNum() {
        var currentUrl = window.location.pathname;
        var current_cari_pg = null;
        //check which url it corresponds to
        if (currentUrl === cari_app_form_pg_1_url) {
            current_cari_pg = 1;
        }
        else if (currentUrl === cari_app_form_pg_2_url) {
            current_cari_pg = 2;
        }
        else if (currentUrl === cari_app_form_pg_3_url) {
            current_cari_pg = 3;
        }
        else if (currentUrl === cari_app_form_pg_4_url) {
            current_cari_pg = 4;
        }
        else {
            return undefined;
        }
        return current_cari_pg;
    }

    render() {
        return (
            <div className="scene_element scene_element--fadeinright">

                {(!this.props.pageLoaded) ?
                    <LoadingPgTemplate />
                : null}

                <div className={(this.props.pageLoaded) ? "" : "display_none"}>
                    <br /><br /><br /><br/>

                    <div className="p-grid">
                        <div className="p-col-12 full-height no_padding_right">
                            <label className="cari_section_title_format">
                                Attachments
                            </label>
                            <p className="cari_small_text">
                            Please submit the following documentation. If you are unsure which version of your document has been uploaded, please upload again to overwrite the old document. Note that required documents are marked with a red asterisk (<strong className="sfu_red">*</strong>). If you would like to have a previously uploaded file deleted from the Beedie server permanently, please contact bdba@sfu.ca.
                            </p>

                            <br/><br/>

                            <CariUploadDocumentsPanel
                                staticUiData={this.props.staticUiData}
                                onFileUpload={this.props.onFileUpload}
                                onFileDelete={this.props.onFileDelete}
                                onFileReplaceUpload={this.props.onFileReplaceUpload}
                                onChangeSetParentState={this.props.onChangeSetParentState}
                                maxFileSize={this.props.maxFileSize}
                                onSaveAddCommentsToDocsUploadedModal={this.props.onSaveAddCommentsToDocsUploadedModal}
                            />
                        </div>
                    </div>

                    <div className="p-grid nav_btn_bar_padding">
                        <div className="p-col-12 scene_element scene_element--fadeinright">
                            <CariAppFormNavBtnBar 
                                page_num={this.getCariFormPageNum()} 
                                match={this.props.match}
                            />
                        </div>
                    </div>   
                </div>

                <CariMainPgFooterView />    
            </div>
        );
    }
}
export default CariAppFormViewPg3;